<template>
  <div class="youtube-embed">
    <div
      v-if="cover && !showVideo"
      class="youtube-embed__cover"
      :style="{ backgroundImage: `url(${cover})` }"
    >
      <div class="youtube-embed__play-container">
        <cdr-button
          :icon-only="true"
          :with-background="false"
          aria-label="Play youtube video"
          class="youtube-embed__play"
          data-analytics-id="play-youtube-embed"
          @click="handleClick"
        >
          <icon-play-stroke />
        </cdr-button>
      </div>
      <div class="youtube-embed__overlay" />
      <img
        :src="logoSrc"
        alt="youtube logo"
        class="youtube-embed__logo"
      >
    </div>
    <iframe
      v-else
      :src="dynamicSrc"
      aria-label="YouTube Video Player"
      frameborder="0"
      class="youtube-embed__iframe"
      :style="{ width: '100%' }"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
</template>

<script>
import { IconPlayStroke, CdrButton } from '@rei/cedar';

export default {
  name: 'YouTubeEmbed',
  components: {
    CdrButton,
    IconPlayStroke,
  },
  props: {
    alt: {
      type: String,
      required: false,
      default: '',
    },
    cover: {
      type: String,
      required: false,
      default: '',
    },
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showVideo: false,
    };
  },
  computed: {
    media() {
      return {
        alt: this.alt,
        xs: this.cover,
      };
    },
    /*
     * If there's a cover, return an auto-playing embed when video is shown
     * otherwise definitely do not autoplay the thing ffs
     */
    dynamicSrc() {
      const { cover, showVideo, src } = this;
      if (cover && showVideo) return `${src}?autoplay=1`;
      return src;
    },
    logoSrc() {
      return '/assets/membership/shared-images/youtube/live.svg';
    },
  },
  methods: {
    /* c8 ignore start */
    handleClick() {
      this.showVideo = true;
    },
    /* c8 ignore end */
  },
};
</script>

<style lang="scss">

.youtube-embed {
  position: relative;
}

.youtube-embed__cover {
  min-height: 200px;
  background: center / cover no-repeat;
}

.youtube-embed__play {
  svg {
    width: 80px;
    height: 80px;
    filter: drop-shadow(0 0.2rem 0.2rem rgba(12, 11, 8, 0.2));
  }
  path {
    fill: $cdr-color-text-inverse;
  }
}

.youtube-embed__play-container,
.youtube-embed__overlay,
.youtube-embed__logo {
  position: absolute;
}

.youtube-embed__play-container,
.youtube-embed__overlay {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.youtube-embed__logo {
  bottom: 1rem;
  right: 1rem;
}

.youtube-embed__overlay {
  background: rgb(0,0,0);
  background: linear-gradient(0deg, rgba(0,0,0,0.6601015406162465) 0%,
      rgba(255,255,255,0) 12%, rgba(255,255,255,0) 100%);
}

.youtube-embed__play-container {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
</style>
